import React from 'react';

// Helpers shared by the central Brandstore admin tabs (BrandstoreManagement, BrandstoreStockTab,
// BrandstoreVouchersTab) — one copy, so their numbers, pagers and status colours stay alike.

export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const qty = (n) => Number(n || 0).toLocaleString('en-IN');

export const ORDER_STATUS_COLORS = {
  PENDING_PAYMENT: { bg: '#FEF3C7', color: '#B45309' },
  CANCELLED:      { bg: '#F3F4F6', color: '#6B7280' },
  ORDER_RECEIVED: { bg: '#FFF8EC', color: '#D97D0A' },
  CONFIRMED:      { bg: '#EFF6FF', color: '#1D4ED8' },
  PROCESSING:     { bg: '#FEF3C7', color: '#92400E' },
  IN_TRANSIT:     { bg: '#DCFCE7', color: '#15803D' },
  DELIVERED:      { bg: '#EDE7F6', color: '#4527A0' },
  RTO:            { bg: '#FEE2E2', color: '#B91C1C' },
};

export function SummaryCard({ label, value, tone }) {
  return (
    <div style={{ background: '#fff', borderRadius: 10, padding: '12px 16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', minWidth: 150, flex: '1 1 150px' }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.4px' }}>{label}</div>
      <div style={{ fontSize: 18, fontWeight: 800, color: tone || '#111827', marginTop: 4 }}>{value}</div>
    </div>
  );
}

export function Pager({ page, totalPages, totalElements, onPage, noun }) {
  if (totalPages <= 1) return null;
  const btn = (disabled) => ({ padding: '6px 12px', borderRadius: 6, border: '1.5px solid #E5E7EB', background: '#fff', color: disabled ? '#D1D5DB' : '#374151', fontSize: 12, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer' });
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderTop: '1px solid #F3F4F6' }}>
      <button onClick={() => onPage(page - 1)} disabled={page === 0} style={btn(page === 0)}>← Prev</button>
      <span style={{ fontSize: 12, color: '#9CA3AF' }}>Page {page + 1} of {totalPages} ({totalElements} {noun})</span>
      <button onClick={() => onPage(page + 1)} disabled={page >= totalPages - 1} style={btn(page >= totalPages - 1)}>Next →</button>
    </div>
  );
}
